import {
	Box,
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControlLabel,
	IconButton,
	Slide,
	Typography
} from '@mui/material';
import {Link} from 'react-router-dom';
import ArrowLeftIcon from '@icons/ArrowLeftIcon';
import CloseIcon from '@icons/CloseIcon';
import {TransitionProps} from '@mui/material/transitions';
import {forwardRef, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import i18n from '@locale/i18n';
import {appConfig} from '@config';


const Transition = forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement;
	},
	ref: React.Ref<unknown>
) {
	return <Slide direction={i18n.t('_dir') === 'rtl' ? 'left' : 'right'} ref={ref} {...props} />;
});

interface IProps {
	open: boolean;
	handleClose: () => void;
}

export default function Drawer({open, handleClose}: IProps) {
	const {t, i18n} = useTranslation();
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const [openLogout, setOpenLogout] = useState(false);
	
	const ssoLogoutRef = useRef<HTMLInputElement>(null);
	
	const handleOpenPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	
	const handleClosePopover = () => {
		setAnchorEl(null);
	};
	
	const openPopover = Boolean(anchorEl);
	
	const changeLanguage = (lang: string) => {
		localStorage.setItem('lang', lang);
		i18n.changeLanguage(lang);
		handleClosePopover();
		handleClose();
	};
	
	const handleLogout = () => {
		if (ssoLogoutRef.current?.checked) {
			let url = appConfig.logout.url;
			url += '?redirect=' + encodeURIComponent(appConfig.logout.redirect);
			document.location.href = url;
		} else {
			localStorage.removeItem('isLogin');
			localStorage.removeItem('rezvan_token');
			document.location.href = '/';
		}
	};
	
	const handleOpenLogoutDialog = () => {
		setOpenLogout(true);
	};
	
	const handleCloseLogoutDialog = () => {
		setOpenLogout(false);
	};
	
	return (
		<>
			<Dialog
				fullScreen
				open={open}
				onClose={handleClose}
				TransitionComponent={Transition}>
				<div className="flex flex-col space-y-2 px-4">
					<div className="flex flex-row h-20 items-center justify-between">
						<IconButton onClick={handleClose}>
							<CloseIcon/>
						</IconButton>
						{
							localStorage.getItem('isLogin') === 'true' &&
							<Button onClick={handleOpenLogoutDialog} sx={{color: 'error.600'}}>{t('logout')}</Button>
						}
					</div>
					<Link to="/privacy">
						<Box
							sx={{bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.100' : theme.palette.background.paper}}
							className="rounded flex flex-row h-14 items-center px-4">
							<Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100'}}
							            className="grow w-0 font-medium">{t('privacy')}</Typography>
							<ArrowLeftIcon/>
						</Box>
					</Link>
					<Link to="/about">
						<Box
							sx={{bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.100' : theme.palette.background.paper}}
							className="rounded flex flex-row h-14 items-center px-4">
							<Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100'}}
							            className="grow w-0 font-medium">{t('about_us')}</Typography>
							<ArrowLeftIcon/>
						</Box>
					</Link>
					<Link to="/settings">
						<Box
							sx={{bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.100' : theme.palette.background.paper}}
							className="rounded flex flex-row h-14 items-center px-4">
							<Typography sx={{color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100'}}
							            className="grow w-0 font-medium">{t('settings')}</Typography>
							<ArrowLeftIcon/>
						</Box>
					</Link>
				</div>
			</Dialog>
			<Dialog open={openLogout} onClose={handleCloseLogoutDialog}>
				<DialogTitle>{t('logout_from_account')}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						{t('logout_description')}
					</DialogContentText>
					<FormControlLabel control={<Checkbox inputRef={ssoLogoutRef} defaultChecked/>} label={t('also_logout_sso')}/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseLogoutDialog}>{t('cancel')}</Button>
					<Button variant="contained" onClick={handleLogout}>{t('logout')}</Button>
				</DialogActions>
			</Dialog>
		</>
	
	);
}
